export default "__VITE_ASSET__CjJRT3jE__"